<template>
    <div>
        <ValidationObserver ref="form" v-slot="{ invalid, validate, dirty }">
            <form
                autocomplete="off"
                @submit.prevent="validate().then(updateSettings)"
            >
                <div class="row">
                    <div class="col-12 mb-2">
                        <h4>Delivery Request Emails</h4>
                        <p class="category no-text-transform">
                            The following email addresses will be sent
                            notifications for new delivery requests and change
                            requests.
                        </p>
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <ValidationProvider
                            v-slot="{ errors }"
                            name="Send To 1"
                            rules="email|required"
                        >
                            <base-input
                                v-model.trim="deliveryRequestEmails[0]"
                                name="deliveryRequestToEmail"
                                label="Send To 1"
                                type="email"
                                autocomplete="new-email"
                                :error="errors[0]"
                            />
                        </ValidationProvider>
                    </div>
                    <div
                        v-for="(email, index) in additionalDeliveryEmails"
                        :key="index"
                        class="col-lg-4 col-md-6"
                    >
                        <ValidationProvider
                            v-slot="{ errors }"
                            :name="`Send To ${index + 2}`"
                            rules="email"
                        >
                            <base-input
                                v-model.trim="deliveryRequestEmails[index + 1]"
                                v-focus
                                focus
                                autocomplete="new-email"
                                :name="`deliveryRequestToEmail${index + 2}`"
                                type="email"
                                :label="`Send To ${index + 2}`"
                                :error="errors[0]"
                            />
                        </ValidationProvider>
                    </div>
                    <div class="col-12">
                        <base-button
                            class="pl-0"
                            link
                            type="primary"
                            @click="deliveryRequestEmails.push('')"
                        >
                            Add Email
                        </base-button>
                    </div>
                </div>
                <el-divider />
                <div class="row">
                    <div class="col-12 mb-2">
                        <h4>Pre-Order Emails</h4>
                        <p class="category no-text-transform">
                            The following email addresses will be sent
                            notifications when a Pre-Order has had its first
                            unit added to it.
                        </p>
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <ValidationProvider
                            v-slot="{ errors }"
                            name="Send To 1"
                            rules="email|required"
                        >
                            <base-input
                                v-model.trim="preOrderEmails[0]"
                                name="preOrderToEmail"
                                label="Send To 1"
                                type="email"
                                autocomplete="new-email"
                                :error="errors[0]"
                            />
                        </ValidationProvider>
                    </div>
                    <div
                        v-for="(email, index) in additionalPreOrderEmails"
                        :key="index"
                        class="col-lg-4 col-md-6"
                    >
                        <ValidationProvider
                            v-slot="{ errors }"
                            :name="`Send To ${index + 2}`"
                            rules="email"
                        >
                            <base-input
                                v-model.trim="preOrderEmails[index + 1]"
                                v-focus
                                focus
                                :name="`preOrderToEmail${index + 2}`"
                                type="email"
                                autocomplete="new-email"
                                :label="`Send To ${index + 2}`"
                                :error="errors[0]"
                            />
                        </ValidationProvider>
                    </div>
                    <div class="col-12">
                        <base-button
                            class="pl-0"
                            link
                            type="primary"
                            @click="preOrderEmails.push('')"
                        >
                            Add Email
                        </base-button>
                    </div>
                </div>
                <el-divider />
                <div class="row">
                    <div class="col-12 mb-2">
                        <h4>Quote Emails</h4>
                        <p class="category no-text-transform">
                            The following email addresses will be sent
                            notifications when a Quote has been created,
                            deleted, or approved/declined by the client.
                        </p>
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <ValidationProvider
                            v-slot="{ errors }"
                            name="Send To 1"
                            rules="email|required"
                        >
                            <base-input
                                v-model.trim="quoteEmails[0]"
                                name="quoteToEmail"
                                label="Send To 1"
                                type="email"
                                autocomplete="new-email"
                                :error="errors[0]"
                            />
                        </ValidationProvider>
                    </div>
                    <div
                        v-for="(email, index) in additionalQuoteEmails"
                        :key="index"
                        class="col-lg-4 col-md-6"
                    >
                        <ValidationProvider
                            v-slot="{ errors }"
                            :name="`Send To ${index + 2}`"
                            rules="email"
                        >
                            <base-input
                                v-model.trim="quoteEmails[index + 1]"
                                v-focus
                                focus
                                :name="`quoteToEmail${index + 2}`"
                                type="email"
                                autocomplete="new-email"
                                :label="`Send To ${index + 2}`"
                                :error="errors[0]"
                            />
                        </ValidationProvider>
                    </div>
                    <div class="col-12">
                        <base-button
                            class="pl-0"
                            link
                            type="primary"
                            @click="quoteEmails.push('')"
                        >
                            Add Email
                        </base-button>
                    </div>
                </div>
                <el-divider />
                <div class="row">
                    <div class="col-12 mb-2">
                        <h4>Stripe Invoice Emails</h4>
                        <p class="category no-text-transform">
                            The following email addresses will be sent
                            notifications when an invoice is paid in the portal.
                        </p>
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <ValidationProvider
                            v-slot="{ errors }"
                            name="Send To 1"
                            rules="email|required"
                        >
                            <base-input
                                v-model.trim="stripeInvoiceEmails[0]"
                                name="stripeInvoiceToEmail"
                                label="Send To 1"
                                type="email"
                                autocomplete="new-email"
                                :error="errors[0]"
                            />
                        </ValidationProvider>
                    </div>
                    <div
                        v-for="(email, index) in additionalStripeEmails"
                        :key="index"
                        class="col-lg-4 col-md-6"
                    >
                        <ValidationProvider
                            v-slot="{ errors }"
                            :name="`Send To ${index + 2}`"
                            rules="email"
                        >
                            <base-input
                                v-model.trim="stripeInvoiceEmails[index + 1]"
                                v-focus
                                focus
                                :name="`stripeInvoiceToEmail${index + 2}`"
                                type="email"
                                autocomplete="new-email"
                                :label="`Send To ${index + 2}`"
                                :error="errors[0]"
                            />
                        </ValidationProvider>
                    </div>
                    <div class="col-12">
                        <base-button
                            class="pl-0"
                            link
                            type="primary"
                            @click="stripeInvoiceEmails.push('')"
                        >
                            Add Email
                        </base-button>
                    </div>
                </div>
                <base-button
                    :disabled="invalid || !dirty"
                    native-type="submit"
                    type="primary"
                    class="btn-fill"
                >
                    Update
                </base-button>
            </form>
        </ValidationObserver>
    </div>
</template>
<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { Divider } from "element-ui";

export default {
    name: "SettingsEmails",
    components: {
        ValidationObserver,
        ValidationProvider,
        [Divider.name]: Divider,
    },
    props: {
        settings: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            deliveryRequestEmails:
                this.settings.deliveryRequestEmails.split(","),
            preOrderEmails: this.settings.preOrderEmails.split(","),
            stripeInvoiceEmails: this.settings.stripeInvoiceEmails.split(","),
            quoteEmails: this.settings.quoteEmails.split(","),
        };
    },
    computed: {
        additionalDeliveryEmails() {
            // exclude first result
            return this.deliveryRequestEmails.slice(1);
        },
        additionalPreOrderEmails() {
            return this.preOrderEmails.slice(1);
        },
        additionalStripeEmails() {
            return this.stripeInvoiceEmails.slice(1);
        },
        additionalQuoteEmails() {
            return this.quoteEmails.slice(1);
        },
    },
    methods: {
        updateSettings() {
            // Remove duplicates, filter empty
            this.deliveryRequestEmails = [
                ...new Set(this.deliveryRequestEmails),
            ].filter((e) => e);
            this.preOrderEmails = [...new Set(this.preOrderEmails)].filter(
                (e) => e,
            );
            this.stripeInvoiceEmails = [
                ...new Set(this.stripeInvoiceEmails),
            ].filter((e) => e);
            this.$emit("updateSettings", {
                input: {
                    deliveryRequestEmails: this.deliveryRequestEmails.join(","),
                    preOrderEmails: this.preOrderEmails.join(","),
                    stripeInvoiceEmails: this.stripeInvoiceEmails.join(","),
                    quoteEmails: this.quoteEmails.join(","),
                },
            });
            this.$refs.form.reset();
        },
    },
};
</script>

<style>
.no-text-transform {
    text-transform: none !important;
}
</style>
